<template>
    <menu-layout
            :loading="loading"
    >
        <row>
            <col2>
                <page-menu
                        :name="$t('auto_t.name')"
                        :title="$t('auto_t.title')"
                        :items="menuItems"
                ></page-menu>
            </col2>
            <col10 style="max-width: 1500px;" >
                <slot></slot>
            </col10>
        </row>
    </menu-layout>
</template>

<script>
import Row from "@/components/layout/Row";
import Col2 from "@/components/layout/Col2";
import PageMenu from "@/components/layout/PageMenu";
import Col10 from "@/components/layout/Col10";
import MenuLayout from "@/components/layout/MenuLayout";
import CurrentUserMixin from "@/mixins/CurrentUserMixin";

export default {
  name: "AutoMenuLayout",
  mixins: [CurrentUserMixin],
  components: {MenuLayout, Col10, PageMenu, Col2, Row},
  props: {
    'loading': {default: false},
    'title': {default: ''},
    'subtitle': {default: ''},
    'menu_items': {
      default: () => {
        return [
        {
          'name': 'Settings',
          'icon': 'fas fa-cog',
          'items': [
              {'name': 'Wallio'},
              {'name': 'Pieter pet'},
              {'name': 'Gekki'},
          ]
        }
      ]
      }
    },
  },
  computed: {
    menuItems() {
      const items = [
        {'name': this.$t('auto_t.clean_duplicates'), 'route': '/auto'},
        {'name': this.$t('auto_t.suggestions'), 'route': '/auto/suggestions'},
      ];
      if (this.is_admin || this.is_manager || this.is_global_admin) {
        items.push({
          'name': this.$t('auto_t.suggestions_overview'),
          'route': '/auto/suggestions-overview',
        });
      }
      return items;
    },
  },
  methods: {
    select_item(item) {
      this.$emit('select_item', item);
    }
  }
}
</script>

<style scoped>

</style>
